import { useRef, useEffect, useCallback } from 'react';

export const useIdleTimer = ({ onIdle, onAction, onActive, throttle, timeout, enabled = true }) => {
  const idleTimeoutRef = useRef(null);
  const throttleRef = useRef(null);
  const isIdleRef = useRef(false);

  const resetIdleTimer = useCallback(() => {
    if (idleTimeoutRef.current) {
      clearTimeout(idleTimeoutRef.current);
    }
    idleTimeoutRef.current = setTimeout(() => {
      isIdleRef.current = true;
      if (onIdle) onIdle();
    }, timeout);
  }, [onIdle, timeout]);

  const handleAction = useCallback(() => {
    const now = Date.now();

    if (!throttleRef.current || now - throttleRef.current > throttle) {
      throttleRef.current = now;
      if (onAction) onAction();

      const wasIdle = isIdleRef.current;
      isIdleRef.current = false;
      resetIdleTimer();

      if (wasIdle && onActive) {
        onActive();
      }
    }
  }, [onAction, onActive, throttle, resetIdleTimer]);

  useEffect(() => {
    if (!enabled) return;

    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];

    events.forEach(event => {
      window.addEventListener(event, handleAction);
    });

    resetIdleTimer();

    return () => {
      events.forEach(event => {
        window.removeEventListener(event, handleAction);
      });
      if (idleTimeoutRef.current) {
        clearTimeout(idleTimeoutRef.current);
      }
    };
  }, [enabled, handleAction, resetIdleTimer]);

  return null;
};
